import React, { Component } from "react";
import {
  Tabs,
  Tab,
  Box,
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHeaderCell,
  TableCell,
  Button
} from "@sainsburys-tech/fable";
import { Link } from "react-router-dom";
import SendScheduleButton from "../SendScheduleButton/SendScheduleButton";
import apiProxy from "../../api/apiProxy.js";
import mapSceneLevel from "../../model/store-commissioning/mapSceneLevel";
import { formatSceneTestSceneValue } from "../../model/store-commissioning/formatSceneLevelValues";
import getZoneSortIdx from "../../model/store-commissioning/getZoneSortOrder";

class StoreTestScenesPage extends Component {
  state = {
    activeTabKey: 1,
    scenes: mapScenes(this.props.scenes.scenes, this.props.store),
    sceneIdBeingTested: null
  };

  setActiveTab = key => {
    this.setState({
      activeTabKey: key
    });
  };

  handleTestClick = status => {
    const scenes = this.state.scenes;
    const sceneId = this.state.activeTabKey;

    const scene = scenes.find(scene => scene.sceneId === sceneId);
    scene.hasFailed = false;
    scene.status = status;
    scenes[sceneId - 1] = scene;

    this.setState({
      scenes: scenes,
      sceneIdBeingTested: sceneId
    });
  };

  handleStatusChange = status => {
    const scenes = this.state.scenes;
    let sceneId = this.state.sceneIdBeingTested;
    if (sceneId == null) {
      sceneId = this.state.activeTabKey;
      this.setState({ sceneIdBeingTested: sceneId });
    }

    const scene = scenes.find(scene => scene.sceneId === sceneId);
    scene.status = status;
    scenes[sceneId - 1] = scene;

    this.setState({ scenes: scenes });
  };

  handleTestComplete = (status, success) => {
    this.handleStatusChange(status);

    const scenes = this.state.scenes;
    const sceneId = this.state.sceneIdBeingTested;

    const scene = scenes.find(scene => scene.sceneId === sceneId);
    scene.hasFailed = !success;
    scenes[sceneId - 1] = scene;

    this.setState({
      scenes: scenes,
      sceneIdBeingTested: null
    });
  };

  handleTestSuccess = status => {
    this.handleTestComplete(status, true);
  };

  handleTestFail = status => {
    this.handleTestComplete(status, false);
  };

  clone = arr => {
    return arr.slice(0);
  };

  render() {
    const scenes = this.state.scenes;

    const scene = scenes.find(x => x.sceneId === this.state.activeTabKey);
    const tabData = this.clone(scene.sceneLevels);

    return (
      <React.Fragment>
        <h3>Test the scene values</h3>
        <p>
          Testing a scene will set all the zones to their scene levels. You can
          then check if the scene levels are correct in the store.
        </p>
        <Tabs activeTab={this.state.activeTabKey.toString()}>
          {scenes.map(scene => {
            return (
              <Tab
                key={scene.sceneId}
                value={scene.sceneId.toString()}
                label={scene.description}
                isSelected={this.state.activeTabKey === scene.sceneId}
                onClick={() => this.setActiveTab(scene.sceneId)}
              />
            );
          })}
        </Tabs>
        <Box className="cb-c-store-test-scenes-page__card-bottom-border">
          <Table isResponsive={true} layout="fixed">
            <TableHeader>
              <TableRow>
                <TableHeaderCell className="cb-c-store-test-scenes-page__scene-table__zone-column">
                  Zone
                </TableHeaderCell>
                <TableHeaderCell className="cb-c-store-test-scenes-page__scene-table__scene-level-column">
                  {scene.description} scene level
                </TableHeaderCell>
              </TableRow>
            </TableHeader>
            <TableBody>
              {tabData.map((rowData, index) => (
                <TableRow key={index}>
                  <TableCell className="cb-c-store-test-scenes-page__scene-table__zone-column">
                    {rowData.zone.name}
                  </TableCell>
                  <TableCell className="cb-c-store-test-scenes-page__scene-table__scene-level-column">
                    {formatSceneTestSceneValue(
                      rowData.zone,
                      rowData.sceneLevel
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <br />
          <SendScheduleButton
            outlined
            label={`Test ${scene.description.toLowerCase()}`}
            sendSchedule={() =>
              apiProxy.storeLighting
                .sendSceneTest(this.props.store.store.storeId, scene.name)
                .then(response => {
                  this.props.onLightingStoresChange();
                  return response.scheduleId;
                })
            }
            successMessage={"Test acknowledged"}
            pendingMessage={"Test pending..."}
            sentMessage={"Test sent..."}
            status={scene.status}
            onStatusChange={this.handleStatusChange}
            onSuccess={this.handleTestSuccess}
            onFail={this.handleTestFail}
            showSpinner={scene.sceneId === this.state.sceneIdBeingTested}
            onClick={this.handleTestClick}
            hasFailed={scene.hasFailed}
          />
        </Box>
        <br />
        <div>
          <Link
            to={{
              pathname: `/lighting/stores/${this.props.store.store.storeId}/commissioning/review`
            }}
          >
            <Button disabled={this.state.sceneIdBeingTested != null}>
              Complete Testing
            </Button>
          </Link>
        </div>
      </React.Fragment>
    );
  }
}

const mapScenes = (scenes, store) => {
  return scenes.map(scene => {
    return {
      sceneId: scenes.indexOf(scene) + 1,
      name: scene.name,
      description: scene.description,
      sceneLevels: store.zoneConfiguration
        .map(zoneConfiguration => {
          const sceneValue = zoneConfiguration.scenes.find(
            zoneConfigScene => zoneConfigScene.scene.name === scene.name
          );

          return {
            zone: {
              name: zoneConfiguration.zone.name,
              zoneType: zoneConfiguration.zone.zoneType
            },
            sceneLevel: mapSceneLevel(
              sceneValue,
              zoneConfiguration.zone.zoneType
            )
          };
        })
        .sort(
          (a, b) =>
            getZoneSortIdx(a.zone.zoneType) - getZoneSortIdx(b.zone.zoneType)
        ),
      status: "",
      hasFailed: false
    };
  });
};

export default StoreTestScenesPage;
